import { Box } from '@mui/material';
import React from 'react';

export function Flex({
  children,
  ...props
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: props.direction || 'row',
      }}
      {...props}
    >
      {children}
    </Box>
  )
}